package com.vamvisions.main.portfolio.data.repository

import com.vamvisions.main.core.domain.DataError
import com.vamvisions.main.core.domain.Result
import com.vamvisions.main.core.domain.map
import com.vamvisions.main.core.domain.preferences.Language
import com.vamvisions.main.portfolio.data.mapper.toDocument
import com.vamvisions.main.portfolio.data.remote.PortfolioApi
import com.vamvisions.main.portfolio.domain.model.Document
import com.vamvisions.main.portfolio.domain.repository.DocumentRepository

/** Fetches the document from the server on every call; nothing is cached. */
class RemoteDocumentRepository(private val api: PortfolioApi) : DocumentRepository {

    override suspend fun get(slug: String, language: Language): Result<Document, DataError.Network> =
        api.getDocument(slug, language).map { it.toDocument(language) }
}
